//additional coverage panel opener
function panelExpander() {
    const basicFeaturesLink = document.querySelector(".features-tab .sk-message.basic-features-link");
    const additionalCoverageLink = document.querySelector(".features-tab .sk-message.additional-coverage-link");
    const basicFeaturesTable = document.querySelector(".features-tab .sk-uigroup--basic-features-table .sk-table");
    const additionalCoverageTable = document.querySelector(".features-tab .sk-uigroup--additional-coverage-table .sk-table");
    if (
        basicFeaturesLink &&
        basicFeaturesTable ||
        additionalCoverageLink &&
        additionalCoverageTable
    ) {
        Skye.Config.Components.TabGroup.onTabOpened = (data) => {
            // console.log("tab change");
            basicFeaturesLink.addEventListener("click", () => {
                basicFeaturesLink.classList.toggle("open");
                basicFeaturesTable.classList.toggle("hide");
            });
           additionalCoverageLink.addEventListener("click", () => {
                additionalCoverageLink.classList.toggle("open");
                additionalCoverageTable.classList.toggle("hide");
            })
        }
    }
}

export { panelExpander }